import { FunctionalityReportFormType } from "./index";
import { PeriodData } from "./shared/types";
import { getRevenuesByReservation } from "./infrastructure/getRevenuesByReservation.query";
import { getRevenuesByFunctionality } from "./infrastructure/getRevenuesByFunctionality.query";
import { calculatePercentageOf, formatCurrency, toPercentage } from "./shared/utils";

export async function executeSuccessLogic(
  queryExecutorApiEndpoint: string,
  { functionalities, startDate, endDate, groups }: FunctionalityReportFormType
) {
  const groupData: PeriodData = {
    period: `${startDate} / ${endDate}`,
    groups: {},
  };

  for (const { name, hotelTickers } of groups) {
    if (!name) {
      throw new Error(`name ${name} is required`);
    }
    if (!startDate || !endDate) {
      throw new Error(`startDate ${startDate} and endDate ${endDate} are required`);
    }
    if (!functionalities || functionalities.length === 0) {
      throw new Error(`functionalities ${functionalities} are required`);
    }

    const [byReservationData, byFunctionalityData] = await Promise.all([
      getRevenuesByReservation(queryExecutorApiEndpoint, { startDate, endDate, hotelTickers }),
      getRevenuesByFunctionality(queryExecutorApiEndpoint, {
        functionalities,
        startDate,
        endDate,
        hotelTickers,
      }),
    ]);

    if (!groupData.groups[name]) {
      groupData.groups[name] = {};
    }

    byReservationData.map(({ hotelTicker, totalReservations, totalRevenue }) => {
      const functionalities = byFunctionalityData.filter(it => it.hotelTicker === hotelTicker);
      const totalFunctionalityReservations = functionalities.reduce(
        (prev, curr) => prev + curr.totalReservations,
        0
      );
      const totalFunctionalityRevenue = functionalities.reduce(
        (prev, curr) => prev + curr.totalRevenue,
        0
      );

      groupData.groups[name][hotelTicker] = {
        byReservation: {
          totalReservations,
          totalRevenue,
          totalRevenueAsString: formatCurrency(totalRevenue),
        },
        // @ts-ignore
        byFunctionality: functionalities.reduce((prev, curr) => {
          const percentageReservations = calculatePercentageOf(
            curr.totalReservations,
            totalFunctionalityReservations
          );
          const percentageRevenue = calculatePercentageOf(
            curr.totalRevenue,
            totalFunctionalityRevenue
          );
          return [
            ...prev,
            {
              tag: curr?.tag.toLocaleLowerCase() || "",
              totalReservations: curr.totalReservations || 0,
              totalRevenue: curr.totalRevenue || 0,
              totalRevenueAsString: formatCurrency(curr.totalRevenue),
              percentageReservations: percentageReservations || 0,
              percentageRevenue: percentageRevenue || 0,
              percentageReservationsAsString: toPercentage(percentageReservations),
              percentageRevenueAsString: toPercentage(percentageRevenue),
            },
          ];
        }, []),
      };
    });
  }

  return groupData;
}
